<template>
  <v-list-item-title>
    {{ $t('From') }}
    <template
      v-for="(sender, idx) in senders"
    >
      <template v-if="idx > 0 && (idx + 1) < senders.length">, </template>
      <template v-if="idx > 0 && (idx + 1) === senders.length">{{ $t(' and ') }}</template>
      <entity
        :key="'sender-' + idx"
        :entity="sender"
      />
    </template>
    {{ $t('to') }}
    <template
      v-for="(receiver, idx) in receivers"
    >
      <template v-if="idx > 0 && (idx + 1) < receivers.length">, </template>
      <template v-if="idx > 0 && (idx + 1) === receivers.length">{{ $t(' and ') }}</template>
      <entity
        :key="'receiver-' + idx"
        :entity="receiver"
      />
    </template>
  </v-list-item-title>
</template>

<script>
import CmifUtils from '@/mixins/CmifUtils'
import Entity from '@/components/Entity'
export default {

  name: 'CmifCorrespAction',

  mixins: [CmifUtils],

  components: {
    Entity
  },

  data () {
    return {
      elementsSenderReceiver: [
        'persName',
        'orgName'
      ]
    }
  },

  computed: {
    senders () {
      return this.getEntities('sent', this.elementsSenderReceiver)
    },
    receivers () {
      return this.getEntities('received', this.elementsSenderReceiver)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
